import { Modal } from 'react-bootstrap';
import OTPInput from 'react-otp-input';

import { maskEmail } from 'utils/utils';

interface OTPModalProps {
  showOTPModal: boolean;
  setShowOTPModal: React.Dispatch<React.SetStateAction<boolean>>;
  passcode: string;
  setPasscode: React.Dispatch<React.SetStateAction<string>>;
  handleVerify: () => void;
  message: string;
  status: string;
  handleResend: () => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  seconds: number;
  disableVerifyPassCode: boolean;
  email: string;
  expiry: number;
}

const OTPModal = ({
  showOTPModal,
  setShowOTPModal,
  passcode,
  setPasscode,
  handleVerify,
  message,
  status,
  handleResend,
  seconds,
  disableVerifyPassCode,
  email,
  expiry,
}: OTPModalProps) => {
  return (
    <Modal
      show={showOTPModal}
      onHide={() => setShowOTPModal(false)}
      backdrop="static"
      keyboard={false}
      centered
      dialogClassName="otp-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>One Time Passcode (OTP)</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '16px' }}>
        <div className="form-group">
          <span>
            We&apos;ve sent a one time passcode to your email address at {!!email && maskEmail(email)}. This code will
            expire in {expiry} minutes. To login to your account, enter the passcode below.
          </span>
        </div>
        <div className="form-group">
          <div className="passcode">
            <label htmlFor="passcode">Enter your OTP</label>
            <div className="d-flex align-items-center">
              <OTPInput
                value={passcode}
                onChange={setPasscode}
                numInputs={6}
                renderSeparator={<span>-</span>}
                renderInput={(props) => <input {...props} style={{ width: '30px', textAlign: 'center' }} />}
                inputType="number"
              />
            </div>
          </div>
        </div>
        {message && <p className={status === 'ERROR' ? 'text-danger' : 'text-success'}>{message}</p>}
        <div className="form-group roundBottomButton">
          <button
            className={`btn btn-primary agiaBlueButton ${(passcode.length !== 6 || disableVerifyPassCode) && 'disabled'}`}
            onClick={handleVerify}
          >
            Confirm Code
          </button>
        </div>
        <div>
          <span>
            Didn&apos;t work?{' '}
            <button
              className={`btn btn-link`}
              style={{ textDecoration: 'none', color: '#3399cc', padding: '0px 0px 4px' }}
              onClick={handleResend}
            >
              Request another code
            </button>{' '}
            in{' '}
            <span>
              {Math.floor(seconds / 60) < 10 ? '0' : ''}
              {Math.floor(seconds / 60)}:{seconds % 60 < 10 ? '0' : ''}
              {seconds % 60}
            </span>
          </span>
          <br />
          <span>If it still does not arrive, please check your SPAM / Junk folder.</span>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default OTPModal;
